import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EditableTitle from '../../components/widgets/EditableTitle';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { PROMPT_MAX_LENGTH } from '../constants';
import css from './PromptTitleEditor.css';

const PromptTitleEditor = ({ initialValue, onSave, onDone }) => {
    const [draft, setDraft] = useState(initialValue);
    const [saving, setSaving] = useState(false);

    const finish = async () => {
        const prompt = draft.trim();
        if (!prompt || prompt === initialValue) {
            onDone();
            return;
        }
        if (saving) return;
        setSaving(true);
        const saved = await onSave(prompt).then(() => true).catch(() => false);
        setSaving(false);
        if (saved) onDone();
    };

    return (
        <div className={css.editRow}>
            <EditableTitle
                value={draft}
                onTextChanged={setDraft}
                onTextChangeComplete={finish}
                containerClass={css.titleContainer}
                selectOnFocus
                maxLength={PROMPT_MAX_LENGTH}
            />
            {saving && <Icon name="loader" size={IconSizes.X_SMALL} className={css.savingSpinner} />}
        </div>
    );
};

PromptTitleEditor.propTypes = {
    initialValue: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
};

export default PromptTitleEditor;
